import React from 'react';
import { brandGradients } from '../theme/palette';

const Strength = () => {
  const strengths = [
    {
      icon: 'fas fa-users-cog',
      title: 'Expert Team & Training',
      description: 'Well-trained team utilizing expertise in vehicle seizure and comprehensive profile investigations (personal and professional).',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'fas fa-network-wired',
      title: 'Strong Network Coverage',
      description: 'Extensive network across Andhra Pradesh, Telangana, Karnataka, and Tamil Nadu with local expertise.',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: 'fas fa-shield-alt',
      title: 'High Confidentiality & Security',
      description: 'Maintain highest degree of confidentiality and security in all records and reports we handle.',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'fas fa-user-tie',
      title: 'Dedicated Field Executives',
      description: 'Committed field executives providing best services to banks with expert guidance and supervision.',
      color: 'from-indigo-500 to-indigo-600'
    },
    {
      icon: 'fas fa-file-contract',
      title: 'In-depth Reporting',
      description: 'Comprehensive, understandable reports in prescribed format with proven track record across all states.',
      color: 'from-teal-500 to-teal-600'
    },
    {
      icon: 'fas fa-clock',
      title: 'Time Management Excellence',
      description: 'Reliable time management ensuring data delivery within time bond with competitive and affordable services.',
      color: 'from-orange-500 to-red-500'
    }
  ];

  return (
    <section className="py-20 lg:py-16 bg-gradient-to-br from-gray-50 to-blue-50">
  <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16 animate-on-scroll">
          <span className="text-[#00a4f4] text-xl font-bold"style={{ color: '#ff70a6' }}>
            Our Strength
          </span>
          <h2 className="text-4xl lg:text-6xl font-black text-gray-800 mt-4 mb-8 leading-tight">
            What Makes Us
            <span className="block text-blue-600">Different</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Our dedicated team of qualified professionals provides personalized services tailored to customer needs. 
            All our services are competitive, affordable, and delivered with the highest standards of professionalism.
          </p>
        </div>

        {/* Strengths Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {strengths.map((strength, index) => (
            <div 
              key={index} 
              className="group relative p-8 bg-white rounded-3xl shadow-1xl hover:shadow-1xl transition-all duration-500 animate-on-scroll border border-gray-100 hover:border-blue-200 overflow-hidden"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Background Gradient on Hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${strength.color.replace('from-', 'from-').replace('to-', 'to-')} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>

              <div className="relative z-10">
                {/* Icon */}
                <div className={`w-16 h-16 bg-gradient-to-r ${strength.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg`}>
                  <i className={`${strength.icon} text-white text-2xl`}></i>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-800 mb-4 group-hover:text-blue-600 transition-colors duration-300">
                  {strength.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {strength.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-10 animate-on-scroll">
          <div className="rounded-3xl p-8 text-white text-center" style={{ background: brandGradients.panel }}>
            <h3 className="text-3xl lg:text-4xl font-bold mb-6">
              Proven Excellence Across South India
            </h3>
            <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
              Our proven work record across Andhra Pradesh, Telangana, Karnataka, and Tamil Nadu demonstrates 
              our commitment to delivering exceptional verification services with complete confidentiality.
            </p>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">100%</div>
                <div className="text-sm opacity-80">Confidential Reports</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">24/7</div>
                <div className="text-sm opacity-80">Professional Support</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">Proven</div>
                <div className="text-sm opacity-80">Track Record</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Strength;